export default "__VITE_ASSET__US5kzXDd__"